module.exports = __webpack_public_path__ + "media/images/icon__point--white@2x-f40bbd3bb711514a06224b86a8942ac5.png";